import type { Release } from '../releases';

export default {
  id: '2026-11-01-company-rates',
  at: '2026-11-01T05:59:00Z',
  title: 'Ставки компании для расчёта своих сил',
  modules: ['budget'],
  items: [
    'На вкладке «Бюджет и маржа» появился блок «Ставки компании»: начисления на ФОТ, накладные и непредвиденные. Новый вариант исполнения «свои силы» берёт их, если в нём своя ставка не задана; сохранённые варианты от смены ставок не меняются.',
    'Менять ставки может тот, кто утверждает бюджеты по всей компании. Пока компания свои ставки не задала, действуют 21,5 %, 10 % и 3 %.',
  ],
  why: 'Ставки были зашиты в портал одинаковыми для всех компаний, а у каждой компании они свои.',
  link: '/projects',
} satisfies Release;
